import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { ManufacturerRangeSelection } from '../check-order-manufacturer.models';
import { ProcessingOrders } from 'src/app/models/supplier-portal/supplier/supplierOrdersProcessing.models';
import { getISOWeeksInYear, getISOWeek } from 'date-fns';
import { OrderHelperService } from 'src/app/services/portal-supplier/order-helper.service';

@Component({
  selector: 'app-check-order-range',
  standalone: false,
  templateUrl: './check-order-range.component.html',
  styleUrls: ['./check-order-range.component.scss'],
})
export class CheckOrderRangeComponent implements OnInit {
  @Input() public selection: ManufacturerRangeSelection | null = null;
  @Input() public productToWorkOn: ProcessingOrders.IProductInOrder | null =
    null;
  @Input() public newBatchToUpload: Partial<ProcessingOrders.IProductBatch> = {
    documents: [],
  };
  @Output()
  public readonly newBatchToUploadChange = new EventEmitter<
    Partial<ProcessingOrders.IProductBatch>
  >();

  @Output()
  public readonly disableButton = new EventEmitter<
    Partial<boolean>
  >();

  currentDate = new Date();
  currentYear = this.currentDate.getFullYear();
  currentWeek = getISOWeek(this.currentDate);

  years: number[] = [];
  weeks: number[] = [];
  maximumBatchQty: number = this.getMaximum;
  public orderService = inject(OrderHelperService);


  ngOnInit() {
    this.newBatchToUpload.serial_from = this.newBatchToUpload.serial_from ?? this.getMinimum;
    this.newBatchToUpload.serial_to = this.newBatchToUpload.serial_to ?? this.getMaximum;
    this.newBatchToUpload.qta = this.newBatchToUpload.serial_to - this.newBatchToUpload.serial_from + 1;
    this.generateYears();
    this.updateBatchYear(this.currentYear);
    this.newBatchToUploadChange.emit(this.newBatchToUpload);
  }

  generateYears() {
    const startYear = 2020; // change as needed
    this.years = [];

    for (let y = this.currentYear; y >= startYear; y--) {
      this.years.push(y);
    }
  }

  updateBatchYear(year: number) {
    this.newBatchToUpload.batch_year = +year;

    const maxWeeks = getISOWeeksInYear(new Date(year, 0, 1));
    let weeks = Array.from({ length: maxWeeks }, (_, i) => i + 1);

    // If selected year is the current year, limit to current week
    if (year === this.currentYear) {
      weeks = weeks.filter(w => w <= this.currentWeek);
    }

    this.weeks = weeks;

    if (!this.weeks.includes(this.newBatchToUpload.batch_week!)) {
      this.newBatchToUpload.batch_week = this.weeks[this.weeks.length - 1];
    }
  }

  updateBatchWeek(week: number) {
    this.newBatchToUpload.batch_week = +week;
  }

  // public updateBatchWeek(value: string): void {
  //   this.emitBatchUpdate({
  //     batch_week: this.parseNumber(value),
  //   });
  // }

  // public updateBatchYear(value: string | number): void {
  //   const year = typeof value === 'string' ? parseInt(value, 10) : value;
  //   this.emitBatchUpdate({
  //     batch_year: year || 0,
  //   });
  // }

  public updateSerialFrom(value: string): void {
    const parsed = this.parseNumber(value);
    const invalid = !value || parsed == null || parsed < 1 || parsed > (this.newBatchToUpload.serial_to ?? this.getMaximum);
    this.disableButton.emit(invalid);
    const qta = +this.newBatchToUpload.serial_to - +(parsed ?? 0) + 1;
    this.newBatchToUpload.qta = Math.max(0, qta);
    this.emitBatchUpdate({ serial_from: parsed });
  }

  public updateSerialTo(value: string): void {
    const parsed = this.parseNumber(value);
    const invalid = !value || parsed == null || parsed < (this.newBatchToUpload.serial_from ?? 1);
    this.disableButton.emit(invalid);
    const qta = +(parsed ?? 0) - +this.newBatchToUpload.serial_from + 1;
    this.newBatchToUpload.qta = Math.max(0, qta);
    this.emitBatchUpdate({ serial_to: parsed });
  }

  private emitBatchUpdate(
    patch: Partial<ProcessingOrders.IProductBatch>,
  ): void {
    this.newBatchToUpload = {
      certification_id: this.productToWorkOn?.supplier_certificate_product_id,
      supplier_certificate_batch_id: this.newBatchToUpload?.supplier_certificate_batch_id ?? 0,
      certification_batch_id: this.newBatchToUpload?.supplier_certificate_batch_id ?? 0,
      documents: this.newBatchToUpload.documents ?? [],
      // qta: this.newBatchToUpload?.serial_to - this.newBatchToUpload?.serial_from + 1,
      ...this.newBatchToUpload,
      ...patch,
    };

    this.newBatchToUploadChange.emit(this.newBatchToUpload);
    console.log('Batch updated', this.newBatchToUpload);
  }

  private parseNumber(value: string): number | undefined {
    const trimmedValue = value.trim();

    if (!trimmedValue) {
      return undefined;
    }

    const parsedValue = Number(trimmedValue);

    return Number.isNaN(parsedValue) ? undefined : parsedValue;
  }

  get getMaximum() {
    return this.orderService?.getBatchMaximumQty ?? this.productToWorkOn?.quantity;
  }
  get getMinimum() {
    return 1;
  }
}
